module.exports = "<div class=modal tabindex=-1 role=dialog> <div class=modal-dialog> <div class=\"modal-content panel\"> <div class=\"panel-heading modal-header\"><h3 class=panel-title>{{'users.delete.title' | translate}}</h3></div> <div class=\"panel-body modal-body\">{{'users.delete.body' | translate}}</div> <div class=\"panel-footer modal-footer\"> <button type=button class=btn ng-click=$hide()>{{'cancel' | translate}}</button> <button type=button class=\"btn btn-new danger\" ng-click=submit()>{{'users.delete' | translate}}</button> </div> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/users/users-delete.modal.html
 ** module id = 144
 ** module chunks = 0
 **/